import Aura from '@primeuix/themes/aura'

import { metroSpbPreset } from './metro-spb-preset'
import { spdPreset } from './spd-preset'

export function resolveThemePreset() {
  const client = import.meta.env.VITE_CLIENT
  if (client === 'spd') return spdPreset
  if (client === 'metro-spb') return metroSpbPreset
  return Aura
}

export const primeVueThemeOptions = {
  darkModeSelector: false as const,
}
